<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h3 class="m-0 font-weight-bold text-primary mb-2">Doctors  
                    <button @click="loadPendingForAprovement" class="btn btn-primary">{{ showForApprovementOnly === true ? 'Show All' : 'Show Pending For Approvement' }}</button>
                    <router-link to="doctors/register" class="btn btn-primary float-right"><icon icon="plus-circle" /> Add New Doctor</router-link>
                </h3>
                </div>
            <div v-if="deleteResponse.success != null" v-bind:class="{ 'alert-success': deleteResponse.success, 'alert-danger': !deleteResponse.success }" class="alert" role="alert">
                {{deleteResponse.message}}
            </div>
            <div class="card-body">
                <div v-if="isUserRoleChanged" class="alert alert-success">You, successfully changed the role of the user! Changes will take effect after 15 minutes or when user login again.</div>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="searchQuery" placeholder="Find doctor by name, riziv, email" aria-label="Find Doctor" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                        <button class="btn btn-primary" @click="onSearchButtonClick">Search</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <b-table show-empty
                             striped
                             :items="doctors"
                             :fields="fields">
                        <template v-slot:cell(approved)="row">
                            <div class="approving-icon">
                                <span class="approved" v-if="row.item.approved"><icon icon="check" /></span>
                                <span class="not-approved" v-else><icon icon="exclamation" /></span>
                            </div>
                        </template>
                        <template v-slot:cell(name)="row">
                            {{ row.item.firstName }} {{ row.item.lastName }}
                        </template>
                        <template v-slot:cell(riziv)="row">
                            {{ row.item.riziv }}
                        </template>
                        <template v-slot:cell(email)="row">
                            {{ row.item.email }}
                        </template>
                        <template v-slot:cell(emailConfirmed)="row">
                            <input type="checkbox" disabled :checked="row.item.emailConfirmed" />
                        </template>
                        <template v-slot:cell(changeUserRoleStatus)="row">
                            <button v-if="row.item.isInRoleAdmin && row.item.email !== currentUserEmail && row.item.approved" type="button" class="btn btn-warining w-100" @click='removeFromRoleAdmin(row.item.doctorId)'>Remove admin rights</button>
                            <button v-if="!row.item.isInRoleAdmin && row.item.email !== currentUserEmail && row.item.approved" type="button" class="btn btn-warining w-100" @click='makeAdmin(row.item.doctorId)'>Give admin rights</button>
                            <button v-if="!row.item.approved" type="button" class="btn btn-success w-100" @click='approveDoctor(row.item.doctorId)'>Approve</button>
                        </template>
                        <!-- <template v-slot:cell(approve)="row">
                            <button v-if="!row.item.approved" type="button" class="btn btn-success" @click='approveDoctor(row.item.doctorId)'>Approve</button>
                        </template> -->
                        <template v-slot:cell(profile)="row">
                            <router-link :to="'/admin/doctors/info/' + row.item.doctorId " class="btn btn-primary">Info</router-link>
                        </template>
                        <template v-slot:cell(modify)="row">
                            <router-link :to="'/admin/doctors/edit/' + row.item.doctorId " class="btn btn-warning">Modify</router-link>
                        </template>
                        <template v-slot:cell(delete)="row">
                            <button @click="enableDeleteModal(row.item)" class="btn btn-danger">Delete</button>
                        </template>
                    </b-table>
                </div>
                <b-pagination-nav 
                    v-model="currentPage" 
                    :link-gen="linkGeneration" 
                    :number-of-pages="totalPages" 
                    use-router 
                    :first-text="this.$t('PAGING_FIRST_PAGE')"
                    :last-text="this.$t('PAGING_LAST_PAGE')" 
                    align="center">
                </b-pagination-nav>
            </div>
        </div>
        <modal :title="modalTitle" :body="modalBody" :button="modalButtonText" @action="deleteDoctor(modalDoctorId)" v-if="showModal" @close="showModal = false"></modal>
    </div>
</template>

<script>
    import Modal from './../../misc/Modal.vue';
    import pagingMixin from './../../../mixins/pagingMixin'
    
    export default {
        mixins: [ pagingMixin ],
        components: {
            modal: Modal
        },
        data() {
            return {
                searchQuery: '',
                doctors: [],
                currentPage: 0,
                totalDoctors: 0,
                totalPages: 1,
                fields: [
                    { key: 'approved', label: 'Approved' },
                    { key: 'name', label: 'Name', sortable: true },
                    { key: 'riziv', label: 'Riziv' },
                    { key: 'email', label: 'Email' },
                    { key: 'emailConfirmed', label: 'Email Confirmed' },
                    { key: 'approve', label: '', tdClass: 'fit' },
                    { key: 'removeFromRoleAdmin', label: '', tdClass: 'fit' },
                    { key: 'changeUserRoleStatus', label: '', tdClass: 'fit' },
                    { key: 'profile', label: 'Profile', tdClass: 'fit' },
                    { key: 'modify', label: 'Modify', tdClass: 'fit' },
                    { key: 'delete', label: 'Delete', tdClass: 'fit' }
                ],
                deleteResponse: {},
                modalBody: "Select 'Delete' below if you are sure you want to delete the doctor ",
                modalTitle: "Delete Confirmation",
                modalButtonText: "Delete",
                showModal: false,
                modalDoctorId: null,
                showForApprovementOnly: false,
                currentUserEmail: undefined,
                isUserRoleChanged: false,
                timers: [],
            }
        },
        methods: {
            removeFromRoleAdmin(doctorId) {
                this
                .$http
                .post(`/api/users/${doctorId}/remove-role-admin`)
                .then(response => {
                    if (response.data) {
                        this.isUserRoleChanged = true;
                        this.loadDoctors();
                        const timer = setTimeout(() => {
                            this.isUserRoleChanged = false;
                        }, 30 * 1000);
                        this.timers.push(timer);
                    } 
                });
            },
            makeAdmin(doctorId) {
                this
                .$http
                .post(`/api/users/${doctorId}/make-admin`)
                .then(response => {
                    if (response.data) {
                        this.isUserRoleChanged = true;
                        this.loadDoctors();
                        const timer = setTimeout(() => {
                            this.isUserRoleChanged = false;
                        }, 30 * 1000);
                        this.timers.push(timer);
                    } 
                });
            },
            enableDeleteModal: function (doctor) {
                this.modalBody = this.modalBody + doctor.firstName + ' ' + doctor.lastName + ' with riziv ' + doctor.riziv + ' and email ' + doctor.email;
                this.modalDoctorId = doctor.doctorId;
                this.showModal = true;
            },
            deleteDoctor: function (doctorId) {
                let self = this;
                this.$http.delete('/api/doctor/delete/' + doctorId)
                    .then(response => {
                        self.deleteResponse = response.data;
                        // get index of object with id: doctorId
                        var removeIndex = self.doctors.map(function (item) { return item.doctorId; }).indexOf(doctorId);
                        // remove object
                        self.doctors.splice(removeIndex, 1);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            loadPendingForAprovement: function () {
                this.showForApprovementOnly = !this.showForApprovementOnly;
                const oldPage = this.currentPage;
                this.currentPage = 1;
                this.$router.push({ 
                    path: this.$route.path,
                    query: { 
                        p: this.currentPage,
                        approvement: this.showForApprovementOnly,
                        q: this.searchQuery
                    }
                });
            },
            loadDoctors: function () {
                this.$http.get('/api/doctor/get-all-on-page?p=' + this.currentPage + '&approvement=' + this.showForApprovementOnly + '&q=' + this.searchQuery)
                    .then(response => {
                        //if (self.doctors.length == 0) {
                        //    self.loadTotaldoctorsCount();
                        //}
                        this.doctors = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            loadTotalDoctorsCount: function () {
                this.$http.get('/api/doctor/count?approvement=' + this.showForApprovementOnly + '&q=' + this.searchQuery)
                    .then(response => {
                        this.totalDoctors = response.data;
                        this.totalPages = this.calculateNumberOfPages(this.totalDoctors);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            changePage: function (value) {
                this.currentPage = value;
                this.loadDoctors();
                this.loadTotalDoctorsCount();
            },
            linkGeneration: function (pageNumber) {
                let queryStringObj = { p: pageNumber, approvement: this.showForApprovementOnly, q: this.searchQuery };
                return {
                    path: '/admin/doctors',
                    query: queryStringObj
                }
            },
            approveDoctor: function (doctorId) {
                let self = this;
                this.$http.post("/api/doctor/approve", { doctorProfileId: doctorId })
                    .then(response => {
                        alert("Doctor has been approved successfully.");
                        this.loadDoctors();
                        this.loadTotalDoctorsCount();
                    })
                    .catch(error => {
                        console.log(error);
                });
            },
            findDoctor: function () {
                this.$router.push({ 
                    path: this.$route.path,
                    query: { 
                        p: this.currentPage,
                        approvement: this.showForApprovementOnly,
                        q: this.searchQuery 
                    }
                });
            },
            onSearchButtonClick: function () {
                this.currentPage = 1;
                this.findDoctor();
                this.loadDoctors();
                this.loadTotalDoctorsCount();
            }
        },
        created: function () {
            this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;
            this.currentUserEmail = this.$store.getters.userEmail;
            
            if (!this.$route.query.approvement) {
                this.showForApprovementOnly = false;
            }
            else {
                this.showForApprovementOnly = JSON.parse(this.$route.query.approvement);
            }
            if (this.$route.query.q) {
                this.searchQuery = this.$route.query.q;
                this.findDoctor();
            }
        },
        destroyed() {
            for (let timer in this.timers) {
                clearTimeout(timer);
            }
        },
        watch: {
            deleteResponse: function (val) {
                setTimeout(() => { this.deleteResponse.success = null }, 3000)
            },
            currentPage: function (val) {
                this.loadDoctors();
                this.loadTotalDoctorsCount();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .approving-icon {
        text-align: center;
        span {
            width: 24px !important;
            height: 24px !important;
            display: block;
            border-radius: 50%;
            color: white;
            line-height: 20px;
            margin: auto;
        }

        .approved {
            background: #12d812 !important;
        }

        .not-approved {
            background: #d86612 !important;
        }
    }

</style>